import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import styles from './style.module.less';
const SectionHead = ({ title, align }) => {
    return (_jsx("div", { className: clsx(styles.sectionHead, align === 'center' && styles.centeredTitle), children: title }));
};
export default SectionHead;
